import {FC} from 'react'
import {downloadTemplateSite, uploadMasiveSite} from '../../../../services'
import {ShowSnackBar} from '../../../../../../util/functions'
import {FormMasive} from '../../../../../../components/UI/Form/MasiveV2'
const MasiveUploadSite: FC = () => {
  const handleUpload = async (formData: FormData) => {
    try {
      const data = await uploadMasiveSite(formData) // Use the service to upload the file
      return data
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
    }
  }
  return (
    <FormMasive
      serviceTemplate={downloadTemplateSite}
      handleSendService={handleUpload}
      title='Site'
    />
  )
}

export {MasiveUploadSite}
